/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Images
 */
import { DropdownArrowIcon } from '../../../../images/icons/DropdownArrow/DropdownArrow'
import { RenewalIcon } from '../../../../images/icons/Renewal/Renewal'

/**
 * Each Policies row from the RenewalsTable component
 *
 * @export
 * @class RenewalsRowQuotes
 * @extends {React.Component<any, any>}
 */
export default class RenewalsRowQuotes extends React.Component<any, any> {
    render() {
        return (
            <div
                className={`table__row table__row__vertical-line
                ${(this.props.referralType === 'inReferral') ? 'pending-referral' : ''}`}
                onClick={(event) => { this.props.action(event) }}
            >
                <div className="column__dropdown">
                    <DropdownArrowIcon color={'#5174AE'} />
                </div>
                <div className="column">{this.props.quote.clientName}</div>
                <div className="column">{this.props.quote.renewalDate}</div>
                <div className="column">{this.props.quote.policyNumber}</div>
                <div className="column">&pound;{this.props.quote.premium}</div>
                <div className="column center-unique-icon">
                    {
                        (this.props.referralType !== 'inReferral') ?
                            <div onClick={() => { this.props.showRenewPolicyPopUp(true, this.props.quote.policyId) }}>
                                <RenewalIcon />
                            </div> :
                            null
                    }
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Renewals/components/RenewalsRowQuotes.tsx